import { BudgetSecondaryNavLink } from 'src/types/budget-secondary-nav-link.enum';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import { useLocation } from 'react-router';
import LiteralsService from 'src/services/literals/LiteralsService';

/** Returns the current selected tab and string representation on the secondary nav */
export const useSecondaryNavSelectedTab = (): {
    selectedTab: BudgetSecondaryNavLink;
    selectedTabName: string;
} => {
    const { pathname } = useLocation();

    if (pathname === BudgetPages.SETTINGS)
        return {
            selectedTab: BudgetSecondaryNavLink.SETTINGS,
            selectedTabName: LiteralsService.getLiteral('SecondaryNavigation.settings')
        };

    if (pathname?.includes(BudgetPages.TRANSACTIONS))
        return {
            selectedTab: BudgetSecondaryNavLink.TRANSACTIONS,
            selectedTabName: LiteralsService.getLiteral('SecondaryNavigation.transactions')
        };

    return {
        selectedTab: BudgetSecondaryNavLink.SPENDSMART,
        selectedTabName: LiteralsService.getLiteral('SecondaryNavigation.spendSmart')
    };
};
